import {LeadProfileController} from "./controller/profile/LeadProfileController";
import LeadProfileModuleConfiguration from "./LeadProfileModuleConfiguration";

LeadProfileModuleConfiguration.createNewModule()
    .controller('leadProfileController', LeadProfileController.instanceConstructor);
